import React, {useEffect, useState} from 'react';
import * as CandidateService from '@app/services/CandidateService';
import {toast} from 'react-toastify';
import '../styles.css';
import {cloneDeep} from 'lodash';
import {Checkbox} from '@components';
import ProcessExtractResult from '@pages/candidate/userinput/ProcessExtractResult';
import ProcessExtractResultModal from '@pages/candidate/userinput/ProcessExtractResultModal';
import * as XLSX from 'xlsx/xlsx.mjs';
import ProcessUploadExcelResult from "@pages/candidate/userinput/ProcessUploadExcelResult";
import {isInteger} from "formik";
import {autoCorrectStrPhone, isYear} from "@app/utils/ValidationUtils";
import {isBlank, readCandidatesFromTemExcelFile, removeStrSpace, stringToArray, strTrim} from "@app/utils/CommonUtils";
import {standardEmails} from "@app/utils/EmailUtils";
import {standardPrefixPhones} from "@app/utils/PhoneUtils";
import {LOCAL_STORAGE_USER_LOGIN_INFO} from "@app/constants/Common";

const UploadExcel = () => {
    const [selectedFiles, setSelectedFiles] = useState([]);
    const [candidates, setCandidates] = useState([]);
    const [processing, setProcessing] = useState(false);
    const [exportExcelFlg, setExportExcelFlg] = useState(false);
    const [cvFailedList, setCVFailedList] = useState([]);
    const [processRefCheckResult, setProcessRefCheckResult] = useState([]);
    const [userLoginInfo, setUserLoginInfo] = useState({});

    useEffect(() => {
        if (!userLoginInfo.id && localStorage.getItem(LOCAL_STORAGE_USER_LOGIN_INFO)) {
            setUserLoginInfo(JSON.parse(localStorage.getItem(LOCAL_STORAGE_USER_LOGIN_INFO)))
        }
    }, [])

    const onSelectFiles = (event) => {
        setSelectedFiles(event.target.files);
    };

    const readUploadFile = (file) => {
        readCandidatesFromTemExcelFile(file, userLoginInfo.id, (cans, headers) => {
            setCandidates(cans)
        })
    }

    const uploadExcelFile = async (e) => {
        e.preventDefault();
        if (selectedFiles.length === 0) return;
        setCandidates([]);
        setProcessing(true);
        let count = 0;
        const canList = [];
        const faileds = [];
        readUploadFile(selectedFiles[0])
    };

    return (
        <div className='container-fluid'>
            <div className='card card-success'>
                <div className='card-header'>
                    <h3 className='card-title'>Upload Excel</h3>
                </div>
                <div className='card-body'>
                    <form encType='multipart/form-data'>
                        <div className='form-group'>
                            <div className='custom-file'>
                                <input
                                    type='file'
                                    className='custom-file-input'
                                    id='customFile'
                                    name='file'
                                    onChange={(event) => onSelectFiles(event)}
                                />
                                <label
                                    className='custom-file-label'
                                    htmlFor='customFile'
                                >
                                    {selectedFiles.length > 0 ? selectedFiles[0].name : ""}
                                </label>
                            </div>
                        </div>
                    </form>
                </div>
                <div className='card-footer'>
                    <div className='row'>
                        <button
                            type='submit'
                            className='btn btn-success'
                            onClick={(e) => uploadExcelFile(e)}
                            disabled={processing}
                            data-toggle='modal' data-target='#inputCommonModal'
                        >
                            {processing ? 'Processing' : 'Upload'}
                        </button>
                    </div>
                </div>
            </div>
            {candidates && candidates.length > 0 &&
            <ProcessUploadExcelResult
                isShow={processRefCheckResult.length === 0}
                candidateList={candidates}
                cvFailedList={[]}
                isExportExcel={false}
                refererInfo={""}
                isFormInput={false}
                hasInputCommon={'true'}
                onProcessRefCheckResult={(result) => setProcessRefCheckResult([result])}
            />
            }

            {processRefCheckResult.length > 0 &&
            <ProcessExtractResultModal extractResults={processRefCheckResult}
                                       isShow={processRefCheckResult.length > 0}
                                       onClose={() => setProcessRefCheckResult([])}/>
            }
        </div>
    );
};

export default UploadExcel;
